import React from 'react';
import { observer } from 'mobx-react';
import { withRouter } from 'react-router-dom';
import { observable } from 'mobx';

import { Table, Column, Button } from '@smartplatform/ui';
import store from '../../store';

@withRouter @observer
export default class List extends React.Component {

	@observable records = null;

	constructor(props) {
		super(props);
		this.init();
	}

	init = async () => {
		this.records = await store.model.CouncilSession.find({ order: 'id asc' });
	};

	create = () => this.props.history.push('/admin/councilsessions/create');

	render() {
		if (!this.records) return '...';

		return <>
			<p>Заседания Совета</p>
			<p><Button className="btn-primary" onClick={this.create}>Создать</Button></p>
			<Table records={this.records} rootPath="/admin">
				<Column width={60} property="id" label="id" />
				<Column property="name" label="Наименование" />
				<Column width={120} property="publish" label="Опубликовано" />
			</Table>
		</>;
	}

}
